import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import { TyreTable } from "./data list tyre/data";

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

interface PressureItem {
  tyres: TyreTable[]; // Array of tyres with battery percentage
}

const Pressure: React.FC<PressureItem> = ({ tyres }) => {
  // Generate battery data from tyres
  const pressureData = tyres.map((tyre) => ({
    id: tyre.id,
    pressure: tyre.pressure, 
 
    // Battery percentage
  }));
  console.log(pressureData);
  // Function to categorize batteries
  const categorizeBatteries = (pressures: { pressure: number }[]): DataItem[] => {
    const categoryCount = { OK: 0, Warning: 0, Attention: 0 };

    pressures.forEach((_pressure) => {
      if (_pressure.pressure > 29 && _pressure.pressure <= 35) {
        categoryCount.OK += 1;
      } else if (_pressure.pressure >= 35 && _pressure.pressure < 70) {
        categoryCount.Warning += 1;
      } else if (_pressure.pressure <= 29) {
        categoryCount.Attention += 1;
      }
    });

    const total = pressures.length;

    // Calculating percentages for each category
    return [
      {
        title: "OK",
        value: categoryCount.OK,
        percentage: (categoryCount.OK / total) * 100,
      },
      {
        title: "High",
        value: categoryCount.Warning,
        percentage: (categoryCount.Warning / total) * 100,
      },
      {
        title: "Low",
        value: categoryCount.Attention,
        percentage: (categoryCount.Attention / total) * 100,
      },
    ];
  };

  // Process battery data to get categorized data for the pie chart     
  const pieChartData = categorizeBatteries(pressureData);

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ marginTop: "0px" }}>Pressure Status</h3>
      <PieChart
        data={pieChartData}
        ariaDescription="Pie chart showing battery health statuses."
        ariaLabel="Battery Status Pie Chart"
        size="small"
        innerMetricDescription="Total Batteries"
        innerMetricValue={pressureData.length.toString()}
        empty={
          <Box textAlign="center" color="inherit">
            <b>No data available</b>
            <Box variant="p" color="inherit">
              There is no data available
            </Box>
          </Box>
        }
        noMatch={
          <Box textAlign="center" color="inherit">
            <b>No matching data</b>
            <Box variant="p" color="inherit">
              There is no matching data to display
            </Box>
          </Box>
        }
      />
    </div>
  );
};

export default Pressure;